var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter } from '@angular/core';
import { PlatformSetting } from '../../../../models/influencer-setting';
import { FormControl, FormGroup } from '@angular/forms';
import { Channel } from '../../../../models/common';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { TranslateService } from '@ngx-translate/core';
import { NewInfluencerChanel } from '../../../../models/influencer/new-influencer';
import { ChannelStatus, platformIconPath } from '../../../app.constants';
var PlatformFieldComponent = /** @class */ (function () {
    function PlatformFieldComponent(influencerService, translate) {
        this.influencerService = influencerService;
        this.translate = translate;
        this.authorizeClick = new EventEmitter();
        this.deleteClick = new EventEmitter();
        this.modifyChannelResponse = new EventEmitter();
        this.handleChange = new EventEmitter();
        this.platformSetting = new PlatformSetting();
        this.handle = new FormControl(undefined, {
            validators: this.validateChannelSetting.bind(this),
            updateOn: 'blur'
        });
        this.isConfirming = false;
    }
    PlatformFieldComponent.prototype.ngOnInit = function () {
        this.platformSetting.platform = this.channelData.platform ? this.channelData.platform.name.toLowerCase() : null;
        this.platformSetting.account = this.channelData.handle;
        this.authChannelForm = new FormGroup({
            handle: this.handle
        });
        if (!this.platformSetting.status) {
            this.platformSetting.status = this.channelData.type || ChannelStatus.UNAUTHORIZE;
        }
        this.isIGChannel = this.channelData.platform.id === platformIconPath.instagram.id ? true : false;
    };
    PlatformFieldComponent.prototype.onAuthorize = function () {
        var data;
        if (this.platformSetting.platform === 'instagram' || this.platformSetting.platform === 'facebook') {
            this.channelData.handle = this.platformSetting.account;
            data = this.channelData;
            this.authorizeClick.emit({
                channel: 'ig',
                data: data
            });
        }
        else {
            this.onFormSubmit();
        }
    };
    PlatformFieldComponent.prototype.onHandleChange = function (evt) {
        var changedFieldName = this.channelData.id > 0 ? this.channelData.id.toString() : "new_" + this.channelData.index;
        this.handleChange.emit({
            fieldName: changedFieldName,
            handle: evt
        });
    };
    PlatformFieldComponent.prototype.reAuthorize = function () {
        this.platformSetting.status = ChannelStatus.UNAUTHORIZE;
        this.channelData.type = ChannelStatus.UNAUTHORIZE;
        this.onAuthorize();
    };
    PlatformFieldComponent.prototype.fieldName = function () {
        if (!this.channelData) {
            return null;
        }
        return this.channelData.id > 0 ? this.channelData.id.toString() : "new_" + this.channelData.index;
    };
    Object.defineProperty(PlatformFieldComponent.prototype, "isUnAuthorize", {
        get: function () {
            return this.platformSetting.status === ChannelStatus.UNAUTHORIZE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformFieldComponent.prototype, "isReAuthorize", {
        get: function () {
            return this.platformSetting.status === ChannelStatus.REAUTHORIZE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformFieldComponent.prototype, "isAuthorized", {
        get: function () {
            return this.platformSetting.status === ChannelStatus.AUTHORIZED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformFieldComponent.prototype, "isError", {
        get: function () {
            return this.platformSetting.status === ChannelStatus.AUTHORIZE_FAILED;
        },
        enumerable: true,
        configurable: true
    });
    PlatformFieldComponent.prototype.onFormSubmit = function () {
        if (this.platformSetting.account && this.platformSetting.account !== '') {
            var data = {
                id: this.channelData.id,
                handle: this.platformSetting.account,
                type: ChannelStatus.AUTHORIZED,
                platform_id: this.channelData.platform ? this.channelData.platform.id : null,
                blog_id: this.channelData.blogId,
                youtubeType: this.channelData.youtubeType,
                fieldName: this.fieldName()
            };
            this.platformSetting.status = ChannelStatus.AUTHORIZED;
            this.isConfirming = true;
            if (this.channelData.id > 0) {
                this.updateChannel(this.channelData.id, data);
            }
            else {
                this.channelData.handle = data.handle;
                this.createNewChannel(data);
            }
        }
    };
    PlatformFieldComponent.prototype.updateChannel = function (channelId, channelData) {
        var _this = this;
        this.influencerService.updateInfluencerChannel(channelId, channelData).subscribe(function (res) {
            _this.isConfirming = false;
            _this.modifyChannelResponse.emit({
                status: 'success',
                type: 'update',
                fieldName: channelData.fieldName,
                data: {
                    id: channelId,
                    handle: channelData.handle
                }
            });
        }, function (err) {
            _this.isConfirming = false;
            _this.platformSetting.status = ChannelStatus.AUTHORIZE_FAILED;
            _this.channelData.type = ChannelStatus.AUTHORIZE_FAILED;
            _this.modifyChannelResponse.emit({
                status: 'error',
                fieldError: channelData.fieldName,
                errorCode: err.error.data
            });
        });
    };
    PlatformFieldComponent.prototype.createNewChannel = function (channelData) {
        var _this = this;
        var newChannel = new NewInfluencerChanel(channelData.platform_id, channelData.type);
        newChannel.handle = channelData.handle;
        this.influencerService.addChannelByInfluencer(channelData.blog_id, newChannel).subscribe(function (res) {
            _this.isConfirming = false;
            _this.modifyChannelResponse.emit(__assign({ status: 'success', type: 'new', handle: channelData.handle, fieldName: channelData.fieldName }, res));
        }, function (err) {
            _this.isConfirming = false;
            _this.platformSetting.status = ChannelStatus.AUTHORIZE_FAILED;
            _this.channelData.type = ChannelStatus.AUTHORIZE_FAILED;
            _this.modifyChannelResponse.emit({
                status: 'error',
                fieldError: channelData.fieldName,
                errorCode: err.error.data
            });
        });
    };
    PlatformFieldComponent.prototype.deleteChannel = function (channel, isMobile) {
        this.deleteClick.emit({
            channel: channel,
            isMobile: isMobile
        });
    };
    PlatformFieldComponent.prototype.validateChannelSetting = function () {
        if (!this.authChannelForm) {
            return null;
        }
        var handle = this.authChannelForm.controls.handle.value;
        if (!handle || ("" + handle).trim() === '') {
            return {
                emptyChannel: true
            };
        }
        return null;
    };
    Object.defineProperty(PlatformFieldComponent.prototype, "isDisabled", {
        get: function () {
            return this.channelData.id > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformFieldComponent.prototype, "unauthorizeButtonLabel", {
        get: function () {
            return this.isIGChannel ? this.translate.instant('influencer_settings.status.authorize') : this.translate.instant('confirm.btn');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformFieldComponent.prototype, "reAuthorizeButtonLabel", {
        get: function () {
            return this.isIGChannel ? this.translate.instant('influencer_settings.status.reauthorize') : this.translate.instant('influencer_settings.status.reconfirm');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformFieldComponent.prototype, "authorizedButtonLabel", {
        get: function () {
            if (this.isConfirming) {
                return this.translate.instant('INFLUENCER.campaign.confirm_modal.btn_confirming');
            }
            return this.isIGChannel ? this.translate.instant('influencer_settings.status.authorized') : this.translate.instant('INFLUENCER.campaign.confirm_modal.btn_confirmed');
        },
        enumerable: true,
        configurable: true
    });
    return PlatformFieldComponent;
}());
export { PlatformFieldComponent };



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-settings/platform-field/platform-field.component.ts.pre-build-optimizer.js